<template>
  <div class="finish-module">
    <img
      class="loading-img"
      src="@/assets/images/import-loading.gif"
    >
    <h2>{{ $t('message["1579"]') }}…</h2>
    <p class="p1">
      {{ $t('message["1583"]') }}
    </p>
    <p class="fs-blue">
      {{ count }}{{ $t('message["643"]') }}…
    </p>
    <a-button
      type="primary"
      class="btn"
      @click="handleGoList"
    >
      {{ $t('message["286"]') }}
    </a-button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      count: 3
    }
  },

  created () {
    this.countTime()
  },

  methods: {
    countTime () {
      let timer = setInterval(() => {
        this.count--
        if (this.count <= 0) {
          this.handleGoList()
          clearInterval(timer)
        }
      }, 1000)
    },
    handleGoList () {
      this.$router.push({
        name: 'configImportList'
      })
      // window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.finish-module {
  text-align: center;
  .loading-img {
    display: block;
    width: 187px;
    margin: 38px auto 26px;
  }
  h2 {
    margin-bottom: 10px;
    font-weight: bold;
  }
  .p1 {
    margin-bottom: 6px;
    color: #B3B3B3;
  }
  .btn {
    display: block;
    margin: 16px auto;
  }
}
</style>
